// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WeiboOutlinedSvg from "@ant-design/icons-svg/es/asn/WeiboOutlined";
import AntdIcon from '../components/AntdIcon';

var WeiboOutlined = function WeiboOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WeiboOutlinedSvg
  }));
};

WeiboOutlined.displayName = 'WeiboOutlined';
export default React.forwardRef(WeiboOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/WeiboOutlined.js
// module id = 2059
// module chunks = 0